export const FETCH_START = 'roadClosures/FETCH_START'
export const FETCH_SUCCESS = 'roadClosures/FETCH_SUCCESS'
export const FETCH_FAILURE = 'roadClosures/FETCH_FAILURE'

export const FETCH_AGENCIES_START = 'roadClosures/agencies/FETCH_START'
export const FETCH_AGENCIES_SUCCESS = 'roadClosures/agencies/FETCH_SUCCESS'
export const FETCH_AGENCIES_FAILURE = 'roadClosures/agencies/FETCH_FAILURE'

export const SELECT_CLOSURES = 'roadClosures/SELECT_CLOSURES'
export const NEXT_CLOSURE = 'roadClosures/NEXT_CLOSURE'
export const PREV_CLOSURE = 'roadClosures/PREV_CLOSURE'
export const CLEAR_SELECTION = 'roadClosures/CLEAR_SELECTION'

export const OPEN_EDITOR = 'roadClosures/OPEN_EDITOR'
export const CLOSE_EDITOR = 'roadClosures/CLOSE_EDITOR'
export const SET_AGENCY_ID = 'roadClosures/SET_AGENCY_ID'
export const SET_REASON = 'roadClosures/SET_REASON'
export const SET_NOTES = 'roadClosures/SET_NOTES'
export const SET_PENDING = 'roadClosures/SET_PENDING'
export const SET_ERROR = 'roadClosures/SET_ERROR'

export const ADD_CLOSURE = 'roadClosures/ADD_CLOSURE'
export const EDIT_CLOSURE = 'roadClosures/EDIT_CLOSURE'
export const REMOVE_CLOSURE = 'roadClosures/REMOVE_CLOSURE'

export const ADD_SEGMENTS = 'roadClosures/ADD_SEGMENTS'
export const REMOVE_SEGMENTS = 'roadClosures/REMOVE_SEGMENTS'
export const HOVER_SEGMENT_START = 'roadClosures/HOVER_SEGMENT_START'
export const HOVER_SEGMENT_END = 'roadClosures/HOVER_SEGMENT_END'
